import { useState, useMemo } from 'react'
import { Input } from 'uikit'
import styled from 'styled-components'
import debounce from 'lodash/debounce'
import { useTranslation } from 'contexts/Localization'

const StyledInput = styled(Input)`
  border-radius: 16px;
  margin-left: auto;
  color:#ffffff;
`

const InputWrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
  }
`

interface Props {
  value?:string
  title:string
  isRequired:boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  showBottom?:boolean
}

const FormInput: React.FC<Props> = ({value,title,isRequired, onChange: onChangeCallback, placeholder = '',showBottom =false }) => {
  const [searchText, setSearchText] = useState('')

  const { t } = useTranslation()

  const debouncedOnChange = useMemo(
    () => debounce((e: React.ChangeEvent<HTMLInputElement>) => onChangeCallback(e), 500),
    [onChangeCallback],
  )

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value)
    debouncedOnChange(e)
  }

  return (
    <div style={{width:'100%'}}>
      <div style={{marginBottom:8,marginLeft:2}}>{title}{isRequired?'*':''}</div>
      <InputWrapper>
        <StyledInput value={value == undefined?searchText:value} onChange={onChange} placeholder={t(placeholder)} />
      </InputWrapper>
      {
        showBottom?<div/>:<div style={{marginBottom:20}}/>
      }
    </div>
  )
}

export default FormInput
